// Pixel layout for the Inventory Surface's 100%-stacked composition bar
// (components/CompositionBar.jsx). Split out so the geometry is node-testable,
// mirroring the inventoryRows / inventoryDistribution split.

export const GAP = 1;    // px between segments (reveals the panel bg behind)
export const MIN_PX = 2; // floor width so a 1-count long-tail segment stays visible + hoverable

// Cumulative x + width per segment for a bar `w` px wide. Each segment gets a
// MIN_PX floor; the remaining width is shared proportionally, so the dominant
// bands stay true-to-scale and the tail stays clickable. Shares are computed
// over the live segment set, so the widths (plus the inter-segment gaps)
// always fill the bar. Returns [{ ...segment, share, x, width }] in input
// order; [] for an empty/invalid set.
export function layoutSegments(segments, w) {
  const list = Array.isArray(segments) ? segments : [];
  const n = list.length;
  if (n === 0) return [];
  const total = list.reduce((sum, s) => sum + s.count, 0) || 1;
  const flexAvail = Math.max(0, w - GAP * (n - 1) - MIN_PX * n);
  const out = [];
  let x = 0;
  for (let i = 0; i < n; i++) {
    const share = list[i].count / total;
    const width = MIN_PX + share * flexAvail;
    out.push({ ...list[i], share, x, width });
    x += width + GAP;
  }
  return out;
}
